import { createSlice } from "@reduxjs/toolkit";

export const fullLengthExam = createSlice({
  name: "fullLengthExam",
  initialState: {
    currentSectionIndex: 0,
    currentQuestionIndex: 0,
    userAnswers: [],
    attemptedQuestions: [],
    reviewMode: false,
    markedQuestions: [],
    showBreakScreen: false,
    sectionCorrectCounts: [],
    examData: null,
    examResults: {
      name: "practice set 2",
      subjectName: "Reading",
      examId: "659fe81c6d324ba54e19e25e",
      classroomId: "66011350ef3b22cd3096520e",
      examType: "assessment",
      totalQuestions: 10,
      correct: 0,
      answeredQuestions: [],
      timeSpent: 0,
      totalPoints: 10,
      obtainedPoints: 0,
      duration: 30,
      concepts: [],
    },
    examId: "",
    time: 10,
    timeLeft: 600,
    showEliminateButtons: false,
    startTime: 0,
    isSavedExam: false,
    savedExamId: "",
    sessionLogs: [],
  },
  reducers: {
    setCurrentQuestionIndex: (state, action) => {
      state.currentQuestionIndex = action.payload;
    },
    setCurrentSectionIndex: (state, action) => {
      state.currentSectionIndex = action.payload;
    },
    setUserAnswers: (state, action) => {
      state.userAnswers = [...action.payload];
    },
    setAttemptedQuestions: (state, action) => {
      state.attemptedQuestions = [...action.payload];
    },
    setReviewMode: (state, action) => {
      state.reviewMode = action.payload;
    },
    setMarkedQuestions: (state, action) => {
      state.markedQuestions = [...action.payload];
    },
    setShowBreakScreen: (state, action) => {
      state.showBreakScreen = action.payload;
    },
    setSectionCorrectCounts: (state, action) => {
      state.sectionCorrectCounts = [...action.payload];
    },
    setExamResults: (state, action) => {
      state.examResults = { ...action.payload };
    },
    setExamData: (state, action) => {
      state.examData = action.payload;
    },
    setExamId: (state, action) => {
      state.examId = action.payload;
    },
    setTime: (state, action) => {
      state.time = action.payload;
    },
    setTimeLeft: (state, action) => {
      state.timeLeft = action.payload;
    },
    setShowEliminateButtons: (state, action) => {
      state.showEliminateButtons = action.payload;
    },
    setStartTime: (state, action) => {
      state.startTime = action.payload;
    },
    setIsSavedExam: (state, action) => {
      state.isSavedExam = action.payload;
    },
    setSavedExamId: (state, action) => {
      state.savedExamId = action.payload;
    },
    setSessionLogs: (state, action) => {
      state.sessionLogs = [...action.payload];
    },
    clearFullLengthExamAll: (state) => {
      state.currentQuestionIndex = 0;
      state.currentSectionIndex = 0;
      state.userAnswers = [];
      state.attemptedQuestions = [];
      state.reviewMode = false;
      state.markedQuestions = [];
      state.showBreakScreen = false;
      state.sectionCorrectCounts = [];
      state.examData = null;
      state.examResults = {
        // this one
        name: "practice set 2",
        subjectName: "Reading",
        examId: "659fe81c6d324ba54e19e25e",
        classroomId: "66011350ef3b22cd3096520e",
        examType: "assessment",
        totalQuestions: 10,
        correct: 0,
        answeredQuestions: [],
        timeSpent: 0,
        totalPoints: 10,
        obtainedPoints: 0,
        duration: 30,
        concepts: [],
      };
      state.examId = "";
      state.time = 10;
      state.timeLeft = 600;
      state.showEliminateButtons = false;
      state.startTime = 0;
      state.isSavedExam = false;
      state.savedExamId = "";
      state.sessionLogs = [];
    },
  },
});

// this is for dispatch
export const {
  setCurrentQuestionIndex,
  setCurrentSectionIndex,
  setUserAnswers,
  setAttemptedQuestions,
  setReviewMode,
  setMarkedQuestions,
  setShowBreakScreen,
  setSectionCorrectCounts,
  setNumericAnswer,
  setExamResults,
  setExamData,
  clearFullLengthExamAll,
  setExamId,
  setTime,
  setTimeLeft,
  setShowEliminateButtons,
  setStartTime,
  setIsSavedExam,
  setSavedExamId,
  setSessionLogs,
} = fullLengthExam.actions;

// this is for configureStore
export default fullLengthExam.reducer;
